export default {
  moistureContent: {
    BS_1377_2: { rev1990: '110459' },
  },
  nuclearFieldDensity: {
    BS_1377_9_Clause_2_5: {
      rev1990: '110458',
    },
  },
  sandReplacement: {
    BS_1377_9_Clause_2_2: {
      rev1990: '110467',
    },
  },
  plateLoading: {
    BS_1377_9_Clause_4_1: {
      rev1990: '110468',
    },
  },
  maximumDryDensity: {
    BS_1377_2_Clause_11_3_11_4: { rev2022: '110477' },
    BS_1377_2_Clause_11_5_11_6: { rev2022: '110480' },
    BS_1377_2_Clause_11_7: { rev2022: '110481' },
  },
  oversizeDetermination: { BS_1377_2_Clause_11: '110478', BS_1377_2_Clause_9_2: '110489' },
  particleDensity: { BS_1377_2_Clause_9_2: { rev2022: '110490' } },
  moistureConditionValue: {
    BS_1377_2_Clause_13_4: { rev2022: '110494' },
    BS_1377_2_Clause_13_5: { rev2022: '110512' },
  },
};
